export default "__VITE_ASSET__CEeJD3z5__";